<script lang="ts">
const __DsBlock = {
	type: 'input',
	icon: 'lucide:images',
	name: '$t:blocks.input_file_m2m.name',
	description: '$t:blocks.input_file_m2m.description',
	category: 'input',
	tags: ['form-control'],
	hidden: ({ isRoot }) => isRoot,
}
</script>
<script lang="ts" setup>
import type { UploadModalResult } from '#layers/assets';
import type { CompositePrimaryKey, GlobalSingleRelationFieldId } from '#layers/data-model';
import type { UseM2MStateReturn } from '~/composables/use-m2m-state';
import type { InputBlockProps } from '~/types/input-block';

import { useOverlay } from '#imports';
import { LazyFileUploadModal } from '#layers/assets';
import { defineBlock } from '#layers/block-engine';
import { getItemPrimaryKey } from '#layers/data-model/utils/primary-key';
import InputListM2M from './InputListM2M.block.vue';

export interface InputFileM2MBlockProps extends Pick<InputBlockProps, 'disabled' | 'disabledNotice' | 'readonly'> {
	fieldId: GlobalSingleRelationFieldId;
	referencedItemKey: CompositePrimaryKey;
}

const props = defineProps<InputFileM2MBlockProps>();

;

async function handleUpload(m2mApi: UseM2MStateReturn) {
	// M2M targets the junction, so resolve the actual file collection to key uploads.
	const fileCollection = m2mApi.targetCollection.value;
	if (!fileCollection) return;

	const modal = useOverlay().create(LazyFileUploadModal, {
		props: {
			closeOnSubmit: false,
		},
	});

	const result = await modal.open().result as UploadModalResult<false>;

	if (result?.files.length) {
		for (const file of result.files) {
			const targetKey = getItemPrimaryKey(file, fileCollection);
			// Just-uploaded files are connected (they already exist) but badge as "created".
			m2mApi.connectTarget(targetKey, { markAsCreated: true });
		}
	}
}
</script>

<template>
	<InputListM2M
		v-bind="props"
		:aria-readonly="readonly"
		count-label="common.n_files"
		:create-action="{
			label: $t('pages.assets.upload'),
			onClick(m2mApi) {
				handleUpload(m2mApi)
			},
		}"
	/>
</template>
